module.exports = __webpack_public_path__ + "img/40_70.52db8a34.png";